

export const primaryButtonStyle =
  "mt-3 md:mt-0 lg:mt-0 w-full md:w-auto lg:w-auto  md:ml-3 disabled:opacity-50 rounded-full py-3  px-6 bg-round-accent text-white  hover:bg-round-accentDark hover:text-white transition ease-in-out duration-300 text-sm whitespace-nowrap";

export const secondaryButtonStyle =
  "mt-3 md:mt-0 lg:mt-0 w-full md:w-auto sm:w-full md:ml-3 disabled:opacity-50 rounded-full py-3  px-6 bg-round-bg text-round-navy border border-round-border hover:bg-round-border hover:text-round-navy transition ease-in-out duration-300 text-sm";

export const warningButtonStyle =
  "ml-3 rounded-full py-1  px-5 bg-red-500 text-white hover:bg-red-700 hover:text-white transition ease-in-out duration-300 text-sm";

export const deleteButton =
  "ml-3 rounded-full py-1 px-3 bg-round-border text-round-navy hover:bg-red-600 hover:text-white text-sm";

export const blurBackground =
  "backdrop-blur flex-none transition-colors duration-500 lg:z-50 bg-white/75 border-b border-round-border supports-backdrop-blur:bg-white/60";

export const greenButtonStyle =
  " disabled:opacity-50 rounded-full py-3  px-5 bg-green-600 text-white  hover:bg-green-800 hover:text-white transition ease-in-out duration-300 text-sm whitespace-nowrap";

export const blurBackgroundEAT =
  "background: #000 backdrop-blur flex-none transition-colors duration-500 lg:z-50 bg-black supports-backdrop-blur:bg-green/40";
